import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ListItem',
  props: {
    isActive: { type: Boolean },
    noPadding: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click'))),
    class: _normalizeClass(["list-item", {
      'list-item--active': __props.isActive,
      'list-item--no-padding': __props.noPadding,
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})